var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowFilter = function SvgIconArrowFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.176 6.998 8.224 3.062a1 1 0 0 1-.288-.704q0-.417.288-.704a.93.93 0 0 1 .704-.304q.416 0 .704.288L16 8.006l-6.368 6.368a.96.96 0 0 1-.704.288.93.93 0 0 1-.704-.304.96.96 0 0 1-.288-.704q0-.4.288-.704l3.952-3.952H1.008q-.415 0-.72-.288A.96.96 0 0 1 0 8.006q0-.417.288-.704a.98.98 0 0 1 .72-.304z"
  })));
};
export default SvgIconArrowFilter;